<template>
  <div class="w-full flex flex-wrap gap-y-3">
    <Field :rules="requiredRule" name="passportNumber" v-slot="{ field, errors: errs }">
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('PassportNo')"
        :max-length="20"
        label-class="w-full"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        direction="flex-col"
      />
    </Field>
    <Field
      :rules="requiredRule"
      name="passportTypeId"
      v-slot="{ field, errors: errs, handleChange }"
    >
      <Dropdown
        :field="field"
        :errors="errs"
        :label="$t('passportTypes')"
        :options="dropdowns.passportTypes"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        direction="flex-col"
        @on-selection="(item) => handleChange(+item?.id)"
      ></Dropdown>
    </Field>
    <Field
      :rules="requiredRule"
      name="currentNationalityID"
      v-slot="{ field, errors: errs, handleChange }"
    >
      <Dropdown
        :field="field"
        :errors="errs"
        :label="$t('Nationality')"
        :options="dropdowns.countries"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        direction="flex-col"
        @on-selection="(item) => handleChange(+item?.id)"
      ></Dropdown>
    </Field>
    <Field :rules="requiredRule" name="dateOfBirth" v-slot="{ field, errors: errs, handleChange }">
      <DatepickerV2
        :field="field"
        :errors="errs"
        :label="$t('fromDate')"
        :default-value="field.value"
        :server-date-format="DATE_FORMAT"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        @on-change="
          (date) => {
            handleChange(date)
          }
        "
      >
      </DatepickerV2>
    </Field>
    <Field :rules="requiredRule" name="fileLastEntryOrChangeStatusDate" v-slot="{ field, errors: errs, handleChange }">
      <DatepickerV2
        :field="field"
        :errors="errs"
        :label="$t('lastEntryDate')"
        :default-value="field.value"
        :server-date-format="DATE_FORMAT"
        class="p-0 md:odd:ps-0 md:px-3 md:even:pe-0 w-full md:w-6/12"
        @on-change="
          (date) => {
            handleChange(date)
          }
        "
      >
      </DatepickerV2>
    </Field>
  </div>
</template>

<script setup>
import DatepickerV2 from '@/components/SimpleForm/DatepickerV2.vue'
import Dropdown from '@/components/SimpleForm/Dropdown.vue'
import TextInput from '@/components/SimpleForm/TextInput.vue'
import { Field } from 'vee-validate'
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

const DATE_FORMAT = 'yyyy-MM-dd'

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

defineProps({
  dropdowns: Object
})
</script>

<style lang="scss" scoped></style>
